import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Exports extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Exports._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Name",
				id: "name",
				/** @param {Exports_Object} obj */
				accessor: obj => (obj.name)
			},
			{
				Header: "Address",
				id: "address",
				/** @param {Exports_Object} obj */
				accessor: obj => (obj.address)
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/exports/${props.original._id}`}>
								<Button color="green-meadow" size="sm" block={true}>
									<i className="fa fa-pencil"/>
								</Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Exports', "")}
							{this.renderHeaderRight("Exports", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
